import { ResourceKey } from 'i18next'

const translation: ResourceKey = {
  en: {
    translation: {
      haveAnAccount: 'Already have an account?',
      signIn: "Log in",
      loginText: "Insert your login and password to enter.",
      login: 'Login',
      password: 'Password',
      confirmPassword: 'Confirm password',
      forgotPassword: 'Forgot my password',
      signInGoogle: 'Log in with Google',
      signInFacebook: 'Log in in with Facebook',
      noAccount: "Do not have an account?",
      createNow: 'Sign up now',
      portuguese: 'Portuguese',
      english: 'English',
      or: 'or',
      passwordPlaceholder: 'Insert password',
      loginPlaceholder: 'CPF',
      wrongUsernameOrPassword: 'Incorrect login or password',

      forgotPasswordText: 'Insert your document to receive an access token.',
      sendToken: 'Send token',
      helpText1: 'Having trouble to access? Open the ',
      chat: 'chat ',
      helpText2: 'to talk with our service or talk via WhatsApp ',
      insertCodeSentTo: 'Insert the sent code to ',
      confirm: 'Confirm',

      reSendCode: 'Resend code',
      sendViaEmail: 'Send to email',

      hi: 'Hi, ',
      access: 'Access report',

      changeDocument: 'Change document',
      SelectDocument: 'Select document',
      document: 'Document',
      createPassword: 'Create new password',
      resetPassword: 'Redefine password',

      documentnotfind: 'Document not find!',
      resetPasswordSuccess: 'Password reset successful',
      resetPasswordError: 'Error resetting password',
      helperNewPassword: 'Create a 6 to 15 character password. The password cannot be the same as your document number.',
      accept: 'I accept the ',
      termsofuse: 'Terms of Use',
      and: ' and ',
      privacy: 'Privacy Policy.',

      "cpf is not valid": "Invalid CPF",
      "no password provided": "Password is a required field",
      "User not found": "User not found",
      "Bad credentials": "Invalid or expired token",
      'token is required': 'Token is a required field',
      'Password is required': 'Password is a required field',
      'Confirm password is required': 'Confirm password is a required field',
      'required field': 'Required field',


      'PIN submission failed': 'There was an error sending the code',
      'Password does not match': 'Password does not match',
      'the password provided cannot be the same as the document number.': 'Password can not be the same as the document number.',
      'token generation failed': 'There was an error generating token',
      'the field new password - min 6 and max 15 characters': 'the field new password - min 6 and max 15 characters',
      'the new password field cannot be empty': 'The new password field cannot be empty',

      espanish: 'Espanish',
      resentPINToken: 'Code resent. Check your email inbox or SMS.',
      birthCertificate: 'Birth certificate',
      foreignDocument: 'Foreign document',
      errorCertificate: 'The document that was entered is not valid or is not registered in our database. Only birth certificates issued after 2010 are accepted as login.',
      documentInvalid: 'The document that was entered is not valid.',

      /* finish example block */

      /* Text report sms */

      seeResults: 'See my result',

      registerDocument: 'Enter the document ',
      expireLink: 'For security reasons, this link expires 24 hours after the report is issued. After this period, access the Patient Portal or download the Hilab app to view all your exams.',
      nDocument: 'Document number',
      validDocument: 'Enter a valid CPF.',
      documentNotRegister: 'Document does not match registry.',
      accessReport: 'Access result',
      documentType: 'Document type',

      goPortalPatient: 'Go to the Patient Portal',
      expiredOrInvalid: 'Invalid or expired link.',
      youReports: 'Access the Patient Portal to view all your reports.',
      portalPAtient: 'Patient Portal',

      donwloadApp: 'Or download our app',
      redirect: "Just a moment, we're redirecting you...",
      errorReport: 'Error loading your report',
      verifyConnection: 'Check your connection and try again. If the error continues, access',
      contact: 'or contact our support:',
      UAU: 'UAU – User/Patient Support Unit',
      CNS: 'CNS (National health card)',
      IssuingAgency: 'Issuing Agency',
      state: 'State',

      country: 'Country',
      writeCountry: 'Enter the country of origin',
      /* finish text report sms */

      /*Country List*/
      Afghanistan: "Afghanistan",
      "South Africa": "South Africa",
      Albania: "Albania",
      Germany: "Germany",
      Andorra: "Andorra",
      Angola: "Angola",
      Anguilla: "Anguilla",
      Antarctic: "Antarctic",
      "Antigua and Barbuda": "Antigua and Barbuda",
      "Saudi Arabia": "Saudi Arabia",
      Algeria: "Algeria",
      Argentina: "Argentina",
      Armenia: "Armenia",
      Aruba: "Aruba",
      Australia: "Australia",
      Austria: "Austria",
      Azerbaijan: "Azerbaijan",
      Bahamas: "Bahamas",
      Bahrain: "Bahrain",
      Bangladesh: "Bangladesh",
      Barbados: "Barbados",
      Belarus: "Belarus",
      Belgium: "Belgium",
      Belize: "Belize",
      Benin: "Benin",
      Bermuda: "Bermuda",
      Bolivia: "Bolivia",
      "Bosnia Herzegovina": "Bosnia Herzegovina",
      Botswana: "Botswana",
      Brazil: "Brazil",
      Brunei: "Brunei",
      Bulgaria: "Bulgaria",
      "Burkina fasso": "Burkina fasso",
      Burundi: "Burundi",
      Bhutan: "Bhutan",
      "Cape Green": "Cape Green",
      Cameroon: "Cameroon",
      Cambodia: "Cambodia",
      Canada: "Canada",
      Canary: "Canary",
      Kazakhstan: "Kazakhstan",
      "Ceuta and Melilla": "Ceuta and Melilla",
      Chad: "Chad",
      Chile: "Chile",
      China: "China",
      Cyprus: "Cyprus",
      Singapore: "Singapore",
      Colombia: "Colombia",
      Consisting: "Consisting",
      Congo: "Congo",
      "North Korea": "North Korea",
      "South Korea": "South Korea",
      "Costa do Marfim": "Costa do Marfim",
      "Costa Rica": "Costa Rica",
      Croatia: "Croatia",
      Cuba: "Cuba",
      Cure: "Cure",
      "Diego Garcia": "Diego Garcia",
      Denmark: "Denmark",
      Djibouti: "Djibouti",
      Dominica: "Dominica",
      Egypt: "Egypt",
      "El Salvador": "El Salvador",
      "United Arab Emirates": "United Arab Emirates",
      Ecuador: "Ecuador",
      Erythrean: "Erythrean",
      Slovakia: "Slovakia",
      Slovenia: "Slovenia",
      Spain: "Spain",
      "U.S": "U.S",
      Estonia: "Estonia",
      Ethiopia: "Ethiopia",
      Fiji: "Fiji",
      Philippines: "Philippines",
      Finland: "Finland",
      France: "France",
      Gabon: "Gabon",
      Gambia: "Gambia",
      Ghana: "Ghana",
      Georgia: "Georgia",
      Gibraltar: "Gibraltar",
      "Britain (United Kingdom, UK)": "Britain (United Kingdom, UK)",
      Grenade: "Grenade",
      Greece: "Greece",
      Gyroon: "Gyroon",
      Guadalupe: "Guadalupe",
      "Guam (United States Territory)": "Guam (United States Territory)",
      Guatemala: "Guatemala",
      Guernsey: "Guernsey",
      Guyana: "Guyana",
      "French Guiana": "French Guiana",
      Guinea: "Guinea",
      "Equatorial Guinea": "Equatorial Guinea",
      "Guinea Bissau": "Guinea Bissau",
      Haiti: "Haiti",
      Netherlands: "Netherlands",
      Honduras: "Honduras",
      "Hong Kong": "Hong Kong",
      Hungary: "Hungary",
      Yemen: "Yemen",
      Bouvet: "Bouvet",
      Rise: "Rise",
      "Clipperton Island": "Clipperton Island",
      Island: "Island",
      "Christmas island": "Christmas island",
      Pitcair: "Pitcair",
      "Island meeting": "Island meeting",
      "Aland Islands": "Aland Islands",
      "Cayman Islands": "Cayman Islands",
      "Coconut islands": "Coconut islands",
      "Cook Islands": "Cook Islands",
      "Faroe Islands": "Faroe Islands",
      "South Georgia Islands and South Sandwich":
        "South Georgia Islands and South Sandwich",
      "Heard and McDonald Islands (Australia Territory)":
        "Heard and McDonald Islands (Australia Territory)",
      Malvinas: "Malvinas",
      "Northern Mariana Islands": "Northern Mariana Islands",
      "Marshall Islands": "Marshall Islands",
      "Smaller islands of the United States":
        "Smaller islands of the United States",
      "Norfolk Islands": "Norfolk Islands",
      "Solomon Islands": "Solomon Islands",
      "Seychelles Islands": "Seychelles Islands",
      "Tokelau Islands": "Tokelau Islands",
      "Turks and Caicos Islands": "Turks and Caicos Islands",
      "Virgin Islands (United States)": "Virgin Islands (United States)",
      "Virgin Islands (England)": "Virgin Islands (England)",
      India: "India",
      Indonesia: "Indonesia",
      Will: "Will",
      Iran: "Iran",
      Iraq: "Iraq",
      Ireland: "Ireland",
      Iceland: "Iceland",
      Israel: "Israel",
      Italy: "Italy",
      Jamaica: "Jamaica",
      Japan: "Japan",
      Jersey: "Jersey",
      Jordan: "Jordan",
      Kiribati: "Kiribati",
      Kosovo: "Kosovo",
      Kuait: "Kuait",
      Laos: "Laos",
      Lesotho: "Lesotho",
      Latvia: "Latvia",
      Lebanon: "Lebanon",
      Liberia: "Liberia",
      Libya: "Libya",
      Liechtenstein: "Liechtenstein",
      Lithuania: "Lithuania",
      Luxembourg: "Luxembourg",
      Macao: "Macao",
      "Macedonia (Yugoslava Republic)": "Macedonia (Yugoslava Republic)",
      Madagascar: "Madagascar",
      Malaysia: "Malaysia",
      Malawi: "Malawi",
      Maldives: "Maldives",
      Mali: "Mali",
      Malta: "Malta",
      Morocco: "Morocco",
      Martinique: "Martinique",
      Maurician: "Maurician",
      Mauritania: "Mauritania",
      Mayotte: "Mayotte",
      Mexico: "Mexico",
      Micronesia: "Micronesia",
      Mozambique: "Mozambique",
      Moldovate: "Moldovate",
      Monkey: "Monkey",
      Mongolia: "Mongolia",
      Montenegro: "Montenegro",
      Montserrat: "Montserrat",
      Myanma: "Myanma",
      Namibia: "Namibia",
      Nauru: "Nauru",
      Nepal: "Nepal",
      Nicaragua: "Nicaragua",
      Niger: "Niger",
      Nigeria: "Nigeria",
      Niue: "Niue",
      Norway: "Norway",
      "New Caledonia": "New Caledonia",
      "New Zealand": "New Zealand",
      Oman: "Oman",
      "Caribbean Netherlands": "Caribbean Netherlands",
      Palau: "Palau",
      Palestine: "Palestine",
      Panama: "Panama",
      "Papua New Guinea": "Papua New Guinea",
      Pakistan: "Pakistan",
      Paraguay: "Paraguay",
      Peru: "Peru",
      "French Polynesian": "French Polynesian",
      Poland: "Poland",
      "Puerto Rico": "Puerto Rico",
      Portugal: "Portugal",
      Qatar: "Qatar",
      Kenya: "Kenya",
      Kyrgyzstan: "Kyrgyzstan",
      "Central African Republic": "Central African Republic",
      "Democratic Republic of Congo": "Democratic Republic of Congo",
      "Dominican Republic": "Dominican Republic",
      "Czech republic": "Czech republic",
      Romania: "Romania",
      Rwanda: "Rwanda",
      "Russia (former USSR) - Russian Federation":
        "Russia (former USSR) - Russian Federation",
      Western: "Western",
      "Saint-Pierre and Miquelon": "Saint-Pierre and Miquelon",
      "American Samoa": "American Samoa",
      "Western samoa": "Western samoa",
      "San Marino": "San Marino",
      "Saint Helen": "Saint Helen",
      "Santa lúcia": "Santa lúcia",
      "São Bartolomeu": "São Bartolomeu",
      "Saint Kitts and Nevis": "Saint Kitts and Nevis",
      "São Martim": "São Martim",
      "São Martinho": "São Martinho",
      "Sao Tome and Principe": "Sao Tome and Principe",
      "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
      Senegal: "Senegal",
      "Sierra Leone": "Sierra Leone",
      Serbia: "Serbia",
      Syria: "Syria",
      Somalia: "Somalia",
      "Sri Lanka": "Sri Lanka",
      Swaziland: "Swaziland",
      Sudan: "Sudan",
      "Southern Sudan": "Southern Sudan",
      Sweden: "Sweden",
      Switzerland: "Switzerland",
      Suriname: "Suriname",
      Svalbard: "Svalbard",
      Tajikistan: "Tajikistan",
      Thailand: "Thailand",
      Taiwan: "Taiwan",
      Tanzania: "Tanzania",
      "British Indian Ocean Territory": "British Indian Ocean Territory",
      "Territories from the south of France":
        "Territories from the south of France",
      "Timor-Leste": "Timor-Leste",
      Togo: "Togo",
      Tonga: "Tonga",
      "Trinidad and Tobago": "Trinidad and Tobago",
      "Tristão da Cunha": "Tristão da Cunha",
      Tunisia: "Tunisia",
      Turkmenistan: "Turkmenistan",
      Turkey: "Turkey",
      Tuvalu: "Tuvalu",
      Ukraine: "Ukraine",
      Uganda: "Uganda",
      Uruguay: "Uruguay",
      Uzbekistan: "Uzbekistan",
      Vanuatu: "Vanuatu",
      Vatican: "Vatican",
      Venezuela: "Venezuela",
      Vietnam: "Vietnam",
      "Wallis and Futuna": "Wallis and Futuna",
      Zambia: "Zambia",
      Zimbabwe: "Zimbabwe",
    },
  },
};

export default translation;
